module.exports = __webpack_public_path__ + "static/media/left_sus_freq.8c75e2b2.png";